// Paleta compartilhada das tags de negociação e dos status de venda do funil.
//
// As classes são escritas por extenso de propósito: não existe `safelist` em
// tailwind.config.js, então um `bg-${cor}-50` montado em runtime seria descartado
// no build de produção. O vocabulário de cores é o mesmo de
// sections/@dashboard/configuracoes/tags/ModalTags.js, para que as etiquetas do
// funil e as do chat sejam configuradas com as mesmas opções.

export const CRM_TAG_COLORS = {
  slate: {
    nome: 'Cinza',
    swatch: 'bg-slate-200',
    pill: 'bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-500/10 dark:text-slate-300 dark:border-slate-500/30',
    dot: 'bg-slate-400',
  },
  orange: {
    nome: 'Laranja',
    swatch: 'bg-orange-200',
    pill: 'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-500/10 dark:text-orange-300 dark:border-orange-500/30',
    dot: 'bg-orange-400',
  },
  yellow: {
    nome: 'Amarelo',
    swatch: 'bg-yellow-200',
    pill: 'bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-500/10 dark:text-yellow-300 dark:border-yellow-500/30',
    dot: 'bg-yellow-400',
  },
  green: {
    nome: 'Verde',
    swatch: 'bg-green-200',
    pill: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-500/10 dark:text-green-300 dark:border-green-500/30',
    dot: 'bg-green-400',
  },
  cyan: {
    nome: 'Ciano',
    swatch: 'bg-cyan-200',
    pill: 'bg-cyan-50 text-cyan-700 border-cyan-200 dark:bg-cyan-500/10 dark:text-cyan-300 dark:border-cyan-500/30',
    dot: 'bg-cyan-400',
  },
  blue: {
    nome: 'Azul',
    swatch: 'bg-blue-200',
    pill: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-500/10 dark:text-blue-300 dark:border-blue-500/30',
    dot: 'bg-blue-400',
  },
  purple: {
    nome: 'Roxo',
    swatch: 'bg-purple-200',
    pill: 'bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-500/10 dark:text-purple-300 dark:border-purple-500/30',
    dot: 'bg-purple-400',
  },
  pink: {
    nome: 'Rosa',
    swatch: 'bg-pink-200',
    pill: 'bg-pink-50 text-pink-700 border-pink-200 dark:bg-pink-500/10 dark:text-pink-300 dark:border-pink-500/30',
    dot: 'bg-pink-400',
  },
  red: {
    nome: 'Vermelho',
    swatch: 'bg-red-200',
    pill: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-500/10 dark:text-red-300 dark:border-red-500/30',
    dot: 'bg-red-400',
  },
};

export const CRM_TAG_COLOR_OPTIONS = Object.keys(CRM_TAG_COLORS).map((value) => ({
  value,
  ...CRM_TAG_COLORS[value],
}));

// Aceita nomes de cor e hex legado (que cai no cinza, como em ModalTags).
export function getCrmTagColor(cor) {
  if (!cor || cor.startsWith('#')) return CRM_TAG_COLORS.slate;
  return CRM_TAG_COLORS[cor] || CRM_TAG_COLORS.slate;
}

// Resolve ids gravados no lead contra a lista vinda de configCrm.
export function resolveTags(ids, lista) {
  if (!Array.isArray(ids) || ids.length === 0 || !Array.isArray(lista)) return [];
  return ids
    .map((id) => lista.find((t) => t._id === String(id)))
    .filter(Boolean);
}

export function resolveStatus(id, lista) {
  if (!id || !Array.isArray(lista)) return null;
  return lista.find((s) => s._id === String(id)) || null;
}
